__turbopack_context__.v({
  "blocksBackgroundColor": "ContentItemPage-module-scss-module__jRa2pW__blocksBackgroundColor",
  "blocksFontColor": "ContentItemPage-module-scss-module__jRa2pW__blocksFontColor",
  "container": "ContentItemPage-module-scss-module__jRa2pW__container",
  "secondaryNavBackgroundColor": "ContentItemPage-module-scss-module__jRa2pW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ContentItemPage-module-scss-module__jRa2pW__themeBackgroundColor",
  "themeFontColor": "ContentItemPage-module-scss-module__jRa2pW__themeFontColor",
});
